<template>
  <div>

    <b-card
      class="business-card"
    >

      <section id="faq-tabs">
        <b-tabs
          vertical
          content-class="col-12 col-md-8 col-lg-9"
          pills
          nav-wrapper-class="faq-navigation col-md-4 col-lg-3 col-12"
          nav-class="nav-left"
        >

          <!-- configuration tab -->
          <b-tab
            v-for="(item, index) in configurations"
            :key="item.name"
            :active="!index"
          >

            <!-- title -->
            <template #title>
              <feather-icon
                :icon="item.icon"
                size="18"
                class="mr-1"
              />
              <span class="font-weight-bold">{{ item.name }}</span>
            </template>

            <!-- <item.component /> -->
            <component :is="item.component" />
          </b-tab>
        <!--/ payment tab -->

        </b-tabs>
      </section>
    </b-card>
    <!--/ configuration tabs pills -->

  </div>
</template>

<script>
import {
  BCard, BTabs, BTab,
} from 'bootstrap-vue'
import SuspiciousEventChecks from './SuspiciousEventChecks.vue'
import EnableInterbankAndInternetTransfer from './EnableInterbankAndInternetTransfer.vue'
import OtherConfigurations from './OtherConfigurations.vue'
import ActivateDeactivateInternetBanking from './ActivateDeactivateInternetBanking.vue'
import TwoFA from './2FA.vue'

export default {
  components: {
    BCard,
    BTabs,
    BTab,
    SuspiciousEventChecks,
    EnableInterbankAndInternetTransfer,
    OtherConfigurations,
    TwoFA,
    ActivateDeactivateInternetBanking,
  },
  data() {
    return {
      configurations: [
        {
          name: this.$t('Activate / Deactivate Internet Banking'),
          icon: 'ToggleLeftIcon',
          component: ActivateDeactivateInternetBanking,
        },
        {
          name: this.$t('Suspicious Events Check'),
          icon: 'CheckSquareIcon',
          component: SuspiciousEventChecks,
        },
        {
          name: this.$t('Enable 2FA'),
          icon: 'LockIcon',
          component: TwoFA,
        },
        {
          name: this.$t('Activate/Deactivate Transfers And Bills'),
          icon: 'ToggleLeftIcon',
          component: EnableInterbankAndInternetTransfer,
        },
        {
          name: this.$t('Other Configurations'),
          icon: 'SettingsIcon',
          component: OtherConfigurations,
        },
      ],
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-faq.scss';
</style>
